import React, { useEffect, useRef, useState } from 'react';

import Rectangle from '../../assets/img/Rectangle.svg';
import { ITEM_EDIT_TAGGING } from '../../utils/constants';
import styles from './dropdown-edit-verbatim-feedback.module.scss';

const DropdownEditVerbatimFeedback = ({ listOption, type, kind, ele, loading, indexEleEdit, setItemChoose }) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef();

  const display = {
    Options: isActive ? `${styles.dropdownContent} ${styles.dropdownContent__visible} ` : styles.dropdownContent,
    width: () => {
      if (type === 'Short') return { maxWidth: '36px' };
    },
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isActive && ref.current && !ref.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isActive]);
  const handleShowSelectLabel = () => {
    if (kind === ITEM_EDIT_TAGGING.HIDE) {
      if (Number(ele?.is_hide) === 0) {
        return 'No';
      }
      if (Number(ele?.is_hide) === 1) {
        return 'Yes';
      }
      if (Boolean(ele?.status) === false || ele?.status == null) {
        return 'No';
      }

      return 'Yes';
    }
  };

  const handleShowListOption = (eleOption) => {
    if (kind === ITEM_EDIT_TAGGING.HIDE) return eleOption ? 'Yes' : 'No';
  };

  return (
    <div className={styles.dropdown} ref={ref}>
      <div
        className={styles.dropdownSelect}
        onKeyDown={() => {}}
        onClick={() => {
          setIsActive((preState) => !preState);
        }}
        style={type && display.width()}
      >
        <p className={styles.dropdownSelect__label}>{handleShowSelectLabel()}</p>
        <span>
          <img src={Rectangle} alt="rectangle" />
        </span>
      </div>
      <div className={display.Options}>
        <div className={styles.dropdownContent__list}>
          {loading ? (
            <div className={styles.dropdown__loading}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            listOption.map((item, index) => {
              return (
                <div
                  className={styles.dropdownContent__item}
                  key={index}
                  onKeyDown={() => {}}
                  onClick={() => {
                    setItemChoose((preState) => {
                      if ([ITEM_EDIT_TAGGING.HIDE].includes(kind)) {
                        return {
                          ...preState,
                          ...ele,
                          indexEleEdit,
                          is_hide: item,
                          status: item,
                          edit: true,
                        };
                      } else {
                        return preState;
                      }
                    });
                    setIsActive(false);
                  }}
                >
                  <p className={styles.dropdownContent__itemLabel}>{handleShowListOption(item)}</p>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};
export default DropdownEditVerbatimFeedback;
